import React, { useEffect, useState } from "react";
import { NAV_LINKS, SOCIAL_MEDIA_LINKS } from "./Helper";
import Icons from "./Icons";

import menucross from "../../assets/images/webp/cross-menu.webp";
import duncanImg from "../../assets/images/webp/duncan-nav-img.webp";
import menuButton from "../../assets/images/webp/menu-icon.webp";
import navLogo from "../../assets/images/webp/nav-logo.png";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import leftArrow from "../../assets/images/svg/navbar-left-arrow.svg";
import rightArrow from "../../assets/images/svg/navbar-right-arrow.svg";

// Import Swiper core and required modules
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

// Header component for the navigation bar
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    // Disable body scroll when the menu is open
    if (isMenuOpen) {
      document.body.style.overflow = "clip";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isMenuOpen]);

  return (
    <div className="bg-dark-purple backdrop-blur-lg w-full fixed top-0 left-1/2 -translate-x-1/2 z-50">
      <div className="2xl:max-w-[1490px] xl:max-w-[1240px] lg:px-5 md:px-8 px-5 mx-auto relative container">
        <div className="flex justify-between items-center 2xl:pt-10 2xl:pb-5 lg:py-8 md:py-6 sm:py-5 py-[17px] relative">
          {isMenuOpen && (
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-screen bg-body-bg h-full z-[49]"></div>
          )}
          {/* Logo and brand name */}
          <div className="flex items-center gap-2.5 xl:gap-0 relative z-50">
            <a href="#">
              <img
                src={navLogo}
                alt="nav-logo"
                className="2xl:w-[54px] md:w-[45px] w-[21px] 2xl:h-[88px] md:h-[65px] h-[34px]"
              />
            </a>
            <p className="text-white sm:[text-shadow:2px_4px_0px_#000000] [text-shadow:1px_2px_0px_#000000] font-normal 2xl:text-custom-8xl md:text-6xl text-custom-4xl leading-100">
              <a href="#">$DUNCE</a>
            </p>
          </div>
          <div className="xl:block hidden relative">
            <Swiper
              slidesPerView={3}
              autoplay={true}
              spaceBetween={27}
              modules={[Navigation]}
              navigation={{
                prevEl: ".prev",
                nextEl: ".next",
              }}
              className="sm:max-w-[540px] max-w-[470px] navbar_slider mx-auto !pb-0"
            >
              {NAV_LINKS.map((value, index) => (
                <SwiperSlide key={index}>
                  <li className="2xl:text-custom-3xl whitespace-nowrap xl:text-2xl font-normal text-xl leading-100 tracking-5 text-white hover:text-soft-blue transition-all duration-300 ease-in-out">
                    <a href={`#${value.link.toLowerCase().replace(/ /g, "-")}`}>
                      {value.link}
                    </a>
                  </li>
                </SwiperSlide>
              ))}
            </Swiper>
            {/* Custom navigation buttons */}
            <div className="prev absolute cursor-pointer top-[14%] left-[-5%] hover:scale-110 transition-all duration-300 ease-in-out">
              <img src={leftArrow} alt="navbar-slider left arrow" />
            </div>
            <div className="next absolute cursor-pointer top-[14%] right-[-5%] hover:scale-110 transition-all duration-300 ease-in-out">
              <img src={rightArrow} alt="navbar-slider-right-arrow" />
            </div>
            <div className="bg-low-shade w-[53px] h-[27px] top-0 left-[-2%] absolute z-40 pointer-events-none -rotate-180"></div>
            <div className="bg-low-shade w-[53px] h-[27px] top-0 right-0 absolute z-40 pointer-events-none "></div>
          </div>
          <div className="sm:flex hidden gap-4 justify-center items-center">
            {SOCIAL_MEDIA_LINKS.map((value, index) => (
              <a
                key={index}
                href={value.link}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="social-links"
              >
                <Icons
                  icon={value.icon}
                  className="w-14 h-14 bg-royal-blue transition-all duration-300 ease-in-out  hover:translate-y-1 cursor-pointer rounded-full"
                />
              </a>
            ))}
          </div>
          {/* Menu button for mobile */}
          <div
            id="menuButton"
            className="xl:hidden relative z-50"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <img
              src={isMenuOpen ? menucross : menuButton}
              alt="menu-icon"
              className={` ${
                isMenuOpen
                  ? "md:w-8 w-6 h-6 md:h-8 "
                  : "md:w-14 sm:w-12 w-[30px] md:h-6 sm:h-5 h-[14px]"
              }`}
            />
          </div>
        </div>
        {/* Mobile menu */}
        <div
          className={`bg-light-purple xl:hidden h-screen fixed inset-0 z-30 transform ${
            isMenuOpen
              ? "-translate-x-0 opacity-100 duration-500 ease-in-out"
              : "-translate-x-full opacity-0 duration-500 ease-in-out"
          }`}
        >
          <div className="flex flex-col h-full justify-between">
            <ul className="pt-36 max-h-[calc(100vh - 200px)] overflow-auto px-5 relative z-20 container mx-auto">
              {NAV_LINKS.map((value, index) => (
                <li
                  key={index}
                  onClick={() => setIsMenuOpen(false)}
                  className="text-white mb-2 font-normal text-custom-5xl hover:text-light-green transition-all duration-300 ease-in-out"
                >
                  <a href={`#${value.link.toLowerCase().replace(/ /g, "-")}`}>
                    {value.link}
                  </a>
                </li>
              ))}
            </ul>

            {/* Buy Now button and social media icons in the mobile menu */}
            <div className="relative z-10 sm:hidden block">
              <div className="pt-14 pb-16 text-center mx-auto flex gap-[30px] justify-center items-center">
                {SOCIAL_MEDIA_LINKS.map((value, index) => (
                  <a
                    key={index}
                    onClick={() => setIsMenuOpen(false)}
                    aria-label="social-links"
                    href={value.link}
                    target="_blank"
                  >
                    <Icons
                      icon={value.icon}
                      className="w-14 h-14 bg-dark-purple border-2 border-dark-purple transition-all duration-300 ease-in-out hover:shadow-none hover:translate-y-1 cursor-pointer rounded-full"
                    />
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Decorative image */}
          <img
            src={duncanImg}
            alt="duncan-navbar-open-image"
            className="w-[298px] sm:h-[380px] h-[422px] absolute bottom-12 sm:-right-[94px] -right-[124px] pointer-events-none"
          />
        </div>
      </div>
    </div>
  );
};

export default Header;
